import ScratchBlocks from "scratch-blocks";
import { defaultColors } from "./themes";
import { customBlockColors } from "@/utils/colorConfig";
import { filterBlocks } from "@/utils/tools";
import { deviceBlockList } from "@/consts/deviceBlock";

// 自定义分类翻译
const customCategoryMessages = {
  en: {
    CATEGORY_DISPLAY: "Display",
    CATEGORY_VOICE: "Voice",
    CATEGORY_IMAGE: "Image",
    CATEGORY_EVENT_CUSTOM: "Event",
    CATEGORY_TIMING: "Timing",
    CATEGORY_SYSTEM: "System",
    DEFAULT_TEXT: "Text",
    SHAPE: "Shape",
  },
  "zh-cn": {
    CATEGORY_DISPLAY: "显示",
    CATEGORY_VOICE: "语音",
    CATEGORY_IMAGE: "图像",
    CATEGORY_EVENT_CUSTOM: "事件",
    CATEGORY_TIMING: "定时",
    CATEGORY_SYSTEM: "系统",
    DEFAULT_TEXT: "文字",
    SHAPE: "形状",
  },
};

// 获取当前语言的翻译
let currentLocale = "zh-cn";
export const setToolboxLocale = (locale) => {
  currentLocale = locale === "zh-cn" ? "zh-cn" : "en";
};
const getMessage = (key, defaultValue) => {
  const messages =
    customCategoryMessages[currentLocale] || customCategoryMessages["en"];
  return messages[key] || defaultValue;
};

const categorySeparator = '<sep gap="36"/>';

const blockSeparator = '<sep gap="36"/>'; // At default scale, about 28px

/* eslint-disable no-unused-vars */
const motion = function (isInitialSetup, isStage, targetId, colors) {
  const stageSelected = ScratchBlocks.ScratchMsgs.translate(
    "MOTION_STAGE_SELECTED",
    "Stage selected: no motion blocks",
  );
  // Note: the category's secondaryColour matches up with the blocks' tertiary color, both used for border color.
  return `
    <category name="%{BKY_CATEGORY_MOTION}" id="motion" colour="${colors.primary
    }" secondaryColour="${colors.tertiary}">
        ${isStage
      ? `
        <label text="${stageSelected}"></label>
        `
      : `

        // 新增积木-2026.04.18
        <block type="motion_advance"/>
        <block type="motion_backward"/>
        <block type="motion_turn_left"/>
        <block type="motion_turn_right"/>
        <block type="motion_stop_move"/>
        <block type="motion_start_line_tracking"/>
        <block type="motion_stop_line_tracking"/>

        <block type="motion_dance" />
        
        <block type="motion_forward">
            <value name="STEPS">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="motion_goback">
            <value name="steps">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="motion_turnright">
            <value name="DEGREES">
                <shadow type="math_angle_1_30">
                    <field name="NUM">15</field>
                </shadow>
            </value>
        </block>
        <block type="motion_turnleft">
            <value name="DEGREES">
                <shadow type="math_angle_1_30">
                    <field name="NUM">15</field>
                </shadow>
            </value>
        </block>
        <!-- <block type="motion_moveleft">
            <value name="STEPS">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="motion_moveright">
            <value name="STEPS">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block> -->

        
        
        // new-dog-start
        <block type="control_servo_reset" />
        <block type="motion_nod" />
        <block type="motion_sway_x" />
        <block type="motion_sway_y" />
        <block type="motion_fall" />
        <block type="motion_retract_leg" />
        <block type="motion_handshake" />
        <block type="motion_stretch" />
        <block type="motion_jump" />
        <block type="self_dog_move_control" />
        // new-dog-end

        <block type="motion_gotoxyz">
            <value name="X">
                <shadow id="movex" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="Y">
                <shadow id="movey" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
            <value name="Z">
                <shadow id="movez" type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="motion_stop">
            <value name="seconds">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="motion_speed">
            <value name="speed">
                <shadow type="math_number">
                    <field name="NUM">5</field>
                </shadow>
            </value>
        </block>
        
        `
    }
        ${categorySeparator}
    </category>
    `;
};

const xmlEscape = function (unsafe) {
  return unsafe.replace(/[<>&'"]/g, (c) => {
    switch (c) {
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case "&":
        return "&amp;";
      case "'":
        return "&apos;";
      case '"':
        return "&quot;";
    }
  });
};

const looks = function (
  isInitialSetup,
  isStage,
  targetId,
  costumeName,
  backdropName,
  colors,
) {
  const hello = ScratchBlocks.ScratchMsgs.translate("LOOKS_HELLO", "Hello!");
  const hmm = ScratchBlocks.ScratchMsgs.translate("LOOKS_HMM", "Hmm...");
  // Note: the category's secondaryColour matches up with the blocks' tertiary color, both used for border color.
  return `
    <category name="%{BKY_CATEGORY_LOOKS}" id="looks" colour="${colors.primary
    }" secondaryColour="${colors.tertiary}">
        ${isStage
      ? ""
      : `
        <block type="looks_sayforsecs">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hello}</field>
                </shadow>
            </value>
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">2</field>
                </shadow>
            </value>
        </block>
        <block type="looks_say">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hello}</field>
                </shadow>
            </value>
        </block>
        <block type="looks_thinkforsecs">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hmm}</field>
                </shadow>
            </value>
            <value name="SECS">
                <shadow type="math_number">
                    <field name="NUM">2</field>
                </shadow>
            </value>
        </block>
        <block type="looks_think">
            <value name="MESSAGE">
                <shadow type="text">
                    <field name="TEXT">${hmm}</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        `
    }
        ${isStage
      ? `
            <block type="looks_switchbackdropto">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_switchbackdroptoandwait">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextbackdrop"/>
        `
      : `
            <block id="${targetId}_switchcostumeto" type="looks_switchcostumeto">
                <value name="COSTUME">
                    <shadow type="looks_costume">
                        <field name="COSTUME">${costumeName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextcostume"/>
            <block type="looks_switchbackdropto">
                <value name="BACKDROP">
                    <shadow type="looks_backdrops">
                        <field name="BACKDROP">${backdropName}</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_nextbackdrop"/>
            ${blockSeparator}
            <block type="looks_changesizeby">
                <value name="CHANGE">
                    <shadow type="math_number">
                        <field name="NUM">10</field>
                    </shadow>
                </value>
            </block>
            <block type="looks_setsizeto">
                <value name="SIZE">
                    <shadow type="math_number">
                        <field name="NUM">100</field>
                    </shadow>
                </value>
            </block>
        `
    }
        ${blockSeparator}
        <block type="looks_changeeffectby">
            <value name="CHANGE">
                <shadow type="math_number">
                    <field name="NUM">25</field>
                </shadow>
            </value>
        </block>
        <block type="looks_seteffectto">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="looks_cleargraphiceffects"/>
        ${blockSeparator}
        ${isStage
      ? ""
      : `
            <block type="looks_show"/>
            <block type="looks_hide"/>
        ${blockSeparator}
            <block type="looks_gotofrontback"/>
            <block type="looks_goforwardbackwardlayers">
                <value name="NUM">
                    <shadow type="math_integer">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
            </block>
        `
    }
        ${isStage
      ? `
            <block id="backdropnumbername" type="looks_backdropnumbername"/>
        `
      : `
            <block id="${targetId}_costumenumbername" type="looks_costumenumbername"/>
            <block id="backdropnumbername" type="looks_backdropnumbername"/>
            <block id="${targetId}_size" type="looks_size"/>
        `
    }
        ${categorySeparator}
    </category>
    `;
};

const sound = function (isInitialSetup, isStage, targetId, soundName, colors) {
  // Note: the category's secondaryColour matches up with the blocks' tertiary color, both used for border color.
  return `
    <category name="%{BKY_CATEGORY_SOUND}" id="sound" colour="${colors.primary}" secondaryColour="${colors.tertiary}">
        <block id="${targetId}_sound_playuntildone" type="sound_playuntildone">
            <value name="SOUND_MENU">
                <shadow type="sound_sounds_menu">
                    <field name="SOUND_MENU">${soundName}</field>
                </shadow>
            </value>
        </block>
        <block id="${targetId}_sound_play" type="sound_play">
            <value name="SOUND_MENU">
                <shadow type="sound_sounds_menu">
                    <field name="SOUND_MENU">${soundName}</field>
                </shadow>
            </value>
        </block>
        <block type="sound_stopallsounds"/>
        ${blockSeparator}
        <block type="sound_changeeffectby">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block type="sound_seteffectto">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
        <block type="sound_cleareffects"/>
        ${blockSeparator}
        <block type="sound_changevolumeby">
            <value name="VOLUME">
                <shadow type="math_number">
                    <field name="NUM">-10</field>
                </shadow>
            </value>
        </block>
        <block type="sound_setvolumeto">
            <value name="VOLUME">
                <shadow type="math_number">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
        <block id="${targetId}_volume" type="sound_volume"/>
        ${categorySeparator}
    </category>
    `;
};

const events = function (isInitialSetup, isStage, targetId, colors) {
  // Note: the category's secondaryColour matches up with the blocks' tertiary color, both used for border color.
  return `
    <category name="%{BKY_CATEGORY_EVENTS}" id="events" colour="${colors.primary
    }" secondaryColour="${colors.tertiary}">
        <block type="event_whenflagclicked"/>
        <block type="event_whenkeypressed">
        </block>
        ${isStage
      ? `
            <block type="event_whenstageclicked"/>
        `
      : `
            <block type="event_whenthisspriteclicked"/>
        `
    }
        <block type="event_whenbackdropswitchesto">
        </block>
        ${blockSeparator}
        <block type="event_whengreaterthan">
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="event_whenbroadcastreceived">
        </block>
        <block type="event_broadcast">
            <value name="BROADCAST_INPUT">
                <shadow type="event_broadcast_menu"></shadow>
            </value>
        </block>
        <block type="event_broadcastandwait">
            <value name="BROADCAST_INPUT">
              <shadow type="event_broadcast_menu"></shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const control = function (isInitialSetup, isStage, targetId, colors) {
  // Note: the category's secondaryColour matches up with the blocks' tertiary color, both used for border color.
  return `
    <category
        name="%{BKY_CATEGORY_CONTROL}"
        id="control"
        colour="${colors.primary}"
        secondaryColour="${colors.tertiary}">
        <block type="control_wait">
            <value name="DURATION">
                <shadow type="math_positive_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="control_repeat">
            <value name="TIMES">
                <shadow type="math_whole_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block id="forever" type="control_forever"/>
        ${blockSeparator}
        <block type="control_if"/>
        <block type="control_if_else"/>
        <block id="wait_until" type="control_wait_until"/>
        <block id="repeat_until" type="control_repeat_until"/>
        ${blockSeparator}
        <block type="control_stop"/>
        ${blockSeparator}
        ${isStage
      ? `
            <block type="control_create_clone_of">
                <value name="CLONE_OPTION">
                    <shadow type="control_create_clone_of_menu"/>
                </value>
            </block>
        `
      : `
            <block type="control_start_as_clone"/>
            <block type="control_create_clone_of">
                <value name="CLONE_OPTION">
                    <shadow type="control_create_clone_of_menu"/>
                </value>
            </block>
            <block type="control_delete_this_clone"/>
        `
    }
        ${categorySeparator}
    </category>
    `;
};

const sensing = function (isInitialSetup, isStage, targetId, colors) {
  const name = ScratchBlocks.ScratchMsgs.translate(
    "SENSING_ASK_TEXT",
    "What's your name?",
  );
  // Note: the category's secondaryColour matches up with the blocks' tertiary color, both used for border color.
  return `
    <category
        name="%{BKY_CATEGORY_SENSING}"
        id="sensing"
        colour="${colors.primary}"
        secondaryColour="${colors.tertiary}">
        ${isStage
      ? ""
      : `
            <block type="sensing_touchingobject">
                <value name="TOUCHINGOBJECTMENU">
                    <shadow type="sensing_touchingobjectmenu"/>
                </value>
            </block>
            <block type="sensing_touchingcolor">
                <value name="COLOR">
                    <shadow type="colour_picker"/>
                </value>
            </block>
            <block type="sensing_coloristouchingcolor">
                <value name="COLOR">
                    <shadow type="colour_picker"/>
                </value>
                <value name="COLOR2">
                    <shadow type="colour_picker"/>
                </value>
            </block>
            <block type="sensing_distanceto">
                <value name="DISTANCETOMENU">
                    <shadow type="sensing_distancetomenu"/>
                </value>
            </block>
            ${blockSeparator}
        `
    }
        ${isInitialSetup
      ? ""
      : `
            <block id="askandwait" type="sensing_askandwait">
                <value name="QUESTION">
                    <shadow type="text">
                        <field name="TEXT">${name}</field>
                    </shadow>
                </value>
            </block>
        `
    }
        <block id="answer" type="sensing_answer"/>
        ${blockSeparator}
        <block type="sensing_keypressed">
            <value name="KEY_OPTION">
                <shadow type="sensing_keyoptions"/>
            </value>
        </block>
        <block type="sensing_mousedown"/>
        <block type="sensing_mousex"/>
        <block type="sensing_mousey"/>
        ${isStage
      ? ""
      : `
            ${blockSeparator}
            '<block type="sensing_setdragmode" id="sensing_setdragmode"></block>'+
            ${blockSeparator}
        `
    }
        ${blockSeparator}
        <block id="loudness" type="sensing_loudness"/>
        ${blockSeparator}
        <block id="timer" type="sensing_timer"/>
        <block type="sensing_resettimer"/>
        ${blockSeparator}
        <block id="of" type="sensing_of">
            <value name="OBJECT">
                <shadow id="sensing_of_object_menu" type="sensing_of_object_menu"/>
            </value>
        </block>
        ${blockSeparator}
        <block id="current" type="sensing_current"/>
        <block type="sensing_dayssince2000"/>
        ${blockSeparator}
        <block type="sensing_username"/>
        ${categorySeparator}
    </category>
    `;
};

const operators = function (isInitialSetup, isStage, targetId, colors) {
  const apple = ScratchBlocks.ScratchMsgs.translate(
    "OPERATORS_JOIN_APPLE",
    "apple",
  );
  const banana = ScratchBlocks.ScratchMsgs.translate(
    "OPERATORS_JOIN_BANANA",
    "banana",
  );
  const letter = ScratchBlocks.ScratchMsgs.translate(
    "OPERATORS_LETTEROF_APPLE",
    "a",
  );
  // Note: the category's secondaryColour matches up with the blocks' tertiary color, both used for border color.
  return `
    <category
        name="%{BKY_CATEGORY_OPERATORS}"
        id="operators"
        colour="${colors.primary}"
        secondaryColour="${colors.tertiary}">
        <block type="operator_add">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_subtract">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_multiply">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_divide">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_random">
            <value name="FROM">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="TO">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_gt">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        <block type="operator_lt">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        <block type="operator_equals">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_and"/>
        <block type="operator_or"/>
        <block type="operator_not"/>
        ${blockSeparator}
        ${isInitialSetup
      ? ""
      : `
            <block type="operator_join">
                <value name="STRING1">
                    <shadow type="text">
                        <field name="TEXT">${apple} </field>
                    </shadow>
                </value>
                <value name="STRING2">
                    <shadow type="text">
                        <field name="TEXT">${banana}</field>
                    </shadow>
                </value>
            </block>
            <block type="operator_letter_of">
                <value name="LETTER">
                    <shadow type="math_whole_number">
                        <field name="NUM">1</field>
                    </shadow>
                </value>
                <value name="STRING">
                    <shadow type="text">
                        <field name="TEXT">${apple}</field>
                    </shadow>
                </value>
            </block>
            <block type="operator_length">
                <value name="STRING">
                    <shadow type="text">
                        <field name="TEXT">${apple}</field>
                    </shadow>
                </value>
            </block>
            <block type="operator_contains" id="operator_contains">
              <value name="STRING1">
                <shadow type="text">
                  <field name="TEXT">${apple}</field>
                </shadow>
              </value>
              <value name="STRING2">
                <shadow type="text">
                  <field name="TEXT">${letter}</field>
                </shadow>
              </value>
            </block>
        `
    }
        ${blockSeparator}
        <block type="operator_mod">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_round">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        ${blockSeparator}
        <block type="operator_mathop">
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        ${categorySeparator}
    </category>
    `;
};

const variables = function (isInitialSetup, isStage, targetId, colors) {
  // Note: the category's secondaryColour matches up with the blocks' tertiary color, both used for border color.
  return `
    <category
        name="%{BKY_CATEGORY_VARIABLES}"
        id="variables"
        colour="${colors.primary}"
        secondaryColour="${colors.tertiary}"
        custom="VARIABLE">
    </category>
    `;
};

const myBlocks = function (isInitialSetup, isStage, targetId, colors) {
  // Note: the category's secondaryColour matches up with the blocks' tertiary color, both used for border color.
  return `
    <category
        name="%{BKY_CATEGORY_MYBLOCKS}"
        id="myBlocks"
        colour="${colors.primary}"
        secondaryColour="${colors.tertiary}"
        custom="PROCEDURE">
    </category>
    `;
};
/* eslint-enable no-unused-vars */

const display = function (isInitialSetup, isStage, targetId, colors) {
  // Note: the category's secondaryColour matches up with the blocks' tertiary color, both used for border color.
  return `
    <category name="${getMessage("CATEGORY_DISPLAY", "Display")}" id="display" colour="${colors.primary}" secondaryColour="${colors.tertiary}">
        <block type="looks_set_rgb">
            <field name="index">1</field>
            <value name="color">
                <shadow type="colour_picker">
                    <field name="COLOUR">#16e6e6</field>
                </shadow>
            </value>
        </block>
        <block type="looks_turn_on_all_lights">
            <value name="color">
                <shadow type="colour_picker">
                    <field name="COLOUR">#16e6e6</field>
                </shadow>
            </value>
        </block>
        <block type="looks_turn_off_all_lights"/>
        <!--<block type="looks_show_text_duration">
            <value name="text">
                <shadow type="text">
                    <field name="TEXT"></field>
                </shadow>
            </value>
            <value name="duration">
                <shadow type="math_number">
                    <field name="NUM">5</field>
                </shadow>
            </value>
        </block>-->
        <block type="looks_show_text">
            <value name="show_text">
                <shadow type="text_limited_30">
                    <field name="TEXT">${getMessage("DEFAULT_TEXT", "Text")}</field>
                </shadow>
            </value>
            <value name="second">
                <shadow type="math_number">
                    <field name="NUM">5</field>
                </shadow>
            </value>
        </block>
        <block type="looks_show_expression">
          <field name="expression">0</field>
        </block>
        <block type="looks_show_image"></block>
        <block type="looks_screen_clear"></block>
    </category>
    `;
};

const voice = function (isInitialSetup, isStage, targetId, colors) {
  return `
    <category name="${getMessage("CATEGORY_VOICE", "Voice")}" id="voice" colour="${colors.primary}" secondaryColour="${colors.tertiary}">
        <block type="sounds_play">
            <value name="text">
                <shadow type="text_limited_30">
                    <field name="TEXT">${getMessage("DEFAULT_TEXT", "Text")}</field>
                </shadow>
            </value>
        </block>
    </category>
    `;
};

const image = function (isInitialSetup, isStage, targetId, colors) {
  return `
    <category name="${getMessage("CATEGORY_IMAGE", "Image")}" id="image" colour="${colors.primary}" secondaryColour="${colors.tertiary}">
        <block type="image_identify_object">
          <field name="expression">${getMessage("SHAPE", "Shape")}</field>
          <value name="text">
              <shadow type="text">
                  <field name="TEXT">${getMessage("DEFAULT_TEXT", "Text")}</field>
              </shadow>
          </value>
        </block>
    </category>
    `;
};

const event_custom = function (isInitialSetup, isStage, targetId, colors) {
  return `
    <category name="${getMessage("CATEGORY_EVENT_CUSTOM", "Event")}" id="event_custom" colour="${colors.primary}" secondaryColour="${colors.tertiary}">
        <block type="event_delay">
            <value name="second">
                <shadow type="math_positive_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="event_repeat">
            <value name="times">
                <shadow type="math_whole_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <!-- <block type="event_gyro">
            <field name="express">greater</field>
            <value name="angle">
                <shadow type="math_whole_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="event_detect_cliff">
                  <value name="angle">
                <shadow type="math_whole_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
        <block type="event_back_detect_cliff">
                  <value name="angle">
                <shadow type="math_whole_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block> -->
        <block type="event_button_pressed">
            <field name="button">left</field>
        </block>
        <block type="event_if_button">
            <field name="button">left</field>
        </block>
        <block type="event_if_else"/>
        <block type="event_repeat_condition">
            <field name="condition_type">satisfy</field>
        </block>
        <!-- <block type="event_break_loop"/> -->
        <block type="event_gyro_reset"/>
        <block type="event_and_or">
            <value name="VALUE1">
                <shadow type="math_number">
                    <field name="NUM"></field>
                </shadow>
            </value>
            <field name="OP">AND</field>
            <value name="VALUE2">
                <shadow type="math_number">
                    <field name="NUM"></field>
                </shadow>
            </value>
        </block>
        <block type="event_left_line_sensor"/>
        <block type="event_right_line_sensor"/>
        <block type="event_gyro_value"/>
        <block type="event_compare">
            <field name="OP">&gt;</field>
            <value name="VALUE1">
                <shadow type="math_number">
                    <field name="NUM"></field>
                </shadow>
            </value>
            <value name="VALUE2">
                <shadow type="math_number">
                    <field name="NUM"></field>
                </shadow>
            </value>
        </block>
    </category>
    `;
};

const timing = function (isInitialSetup, isStage, targetId, colors) {
  return `
    <category name="${getMessage("CATEGORY_TIMING", "Timing")}" id="timing" colour="${colors.primary}" secondaryColour="${colors.tertiary}">
        <block type="event_interval">
            <value name="second">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="total_times">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
    </category>
    `;
};

const system = function (isInitialSetup, isStage, targetId, colors) {
  return `
    <category name="${getMessage("CATEGORY_SYSTEM", "System")}" id="system" colour="${colors.primary}" secondaryColour="${colors.tertiary}">
        <block type="sys_set_volume">
          <value name="volume">
              <shadow type="math_number">
                  <field name="NUM">80</field>
              </shadow>Z
          </value>
        </block>
        <block type="sys_reboot"/>
        <block type="looks_theme"/>
    </category>
    `;
};

const xmlOpen = '<xml style="display: none">';
const xmlClose = "</xml>";

/**
 * @param {!boolean} isInitialSetup - Whether the toolbox is for initial setup. If the mode is "initial setup",
 * blocks with localized default parameters (e.g. ask and wait) should not be loaded. (LLK/scratch-gui#5445)
 * @param {?boolean} isStage - Whether the toolbox is for a stage-type target. This is always set to true
 * when isInitialSetup is true.
 * @param {?string} targetId - The current editing target
 * @param {?Array.<object>} categoriesXML - optional array of `{id,xml}` for categories. This can include both core
 * and other extensions: core extensions will be placed in the normal Scratch order; others will go at the bottom.
 * @property {string} id - the extension / category ID.
 * @property {string} xml - the `<category>...</category>` XML for this extension / category.
 * @param {?string} costumeName - The name of the default selected costume dropdown.
 * @param {?string} backdropName - The name of the default selected backdrop dropdown.
 * @param {?string} soundName -  The name of the default selected sound dropdown.
 * @param {?object} colors - The colors for the theme.
 * @returns {string} - a ScratchBlocks-style XML document for the contents of the toolbox.
 */
const makeToolboxXML = function (
  isInitialSetup,
  isStage = true,
  targetId,
  categoriesXML = [],
  costumeName = "",
  backdropName = "",
  soundName = "",
  colors = defaultColors,
) {
  let curDevice = {};
  try {
    const stroedData = localStorage.getItem("selectedDeviceData");
    curDevice = stroedData
      ? JSON.parse(localStorage.getItem("selectedDeviceData"))
      : {};
  } catch (e) {
    // ignore
  }

  const curDeiceType = curDevice?.deviceType || 1; // 默认是坦克车

  isStage = isInitialSetup || isStage;
  const gap = [categorySeparator];

  costumeName = xmlEscape(costumeName);
  backdropName = xmlEscape(backdropName);
  soundName = xmlEscape(soundName);

  categoriesXML = categoriesXML.slice();
  const moveCategory = (categoryId) => {
    const index = categoriesXML.findIndex(
      (categoryInfo) => categoryInfo.id === categoryId,
    );
    if (index >= 0) {
      // remove the category from categoriesXML and return its XML
      const [categoryInfo] = categoriesXML.splice(index, 1);
      return categoryInfo.xml;
    }
    // return `undefined`
  };

  const curDeviceBlockList = deviceBlockList[String(curDeiceType)];

  let motionBlockLen = null;
  let motionXML =
    moveCategory("motion") ||
    motion(isInitialSetup, isStage, targetId, colors.motion);
  const motionDataList = curDeviceBlockList["motion"];
  if (!motionDataList.includes("all")) {
    const filtedData = filterBlocks(motionXML, motionDataList);
    motionXML = filtedData.xml;
    motionBlockLen = filtedData.blockLen;
  }

  let displayBlockLen = null;
  let displayXML =
    moveCategory("display") ||
    display(isInitialSetup, isStage, targetId, customBlockColors.display);
  const displayDataList = curDeviceBlockList["display"];
  if (!displayDataList.includes("all")) {
    const filtedData = filterBlocks(displayXML, displayDataList);
    displayXML = filtedData.xml;
    displayBlockLen = filtedData.blockLen;
  }

  let voiceBlockLen = null;
  let voiceXML =
    moveCategory("voice") ||
    voice(isInitialSetup, isStage, targetId, customBlockColors.voice);
  const voiceDataList = curDeviceBlockList["voice"];
  if (!voiceDataList.includes("all")) {
    const filtedData = filterBlocks(voiceXML, voiceDataList);
    voiceXML = filtedData.xml;
    voiceBlockLen = filtedData.blockLen;
  }

  let imageBlockLen = null;
  let imageXML =
    moveCategory("image") ||
    image(isInitialSetup, isStage, targetId, customBlockColors.image);
  const imageDataList = curDeviceBlockList["image"];
  if (!imageDataList.includes("all")) {
    const filtedData = filterBlocks(imageXML, imageDataList);
    imageXML = filtedData.xml;
    imageBlockLen = filtedData.blockLen;
  }

  let eventBlockLen = null;
  let eventCustomXML =
    moveCategory("event_custom") ||
    event_custom(
      isInitialSetup,
      isStage,
      targetId,
      customBlockColors.event_custom,
    );
  const eventCustomDataList = curDeviceBlockList["event_custom"];
  if (!eventCustomDataList.includes("all")) {
    const filtedData = filterBlocks(eventCustomXML, eventCustomDataList);
    eventCustomXML = filtedData.xml;
    eventBlockLen = filtedData.blockLen;
  }

  let timingBlockLen = null;
  let timingXML =
    moveCategory("timing") ||
    timing(isInitialSetup, isStage, targetId, customBlockColors.timing);
  const timingDataList = curDeviceBlockList["timing"];
  if (!timingDataList.includes("all")) {
    const filtedData = filterBlocks(timingXML, timingDataList);
    timingXML = filtedData.xml;
    timingBlockLen = filtedData.blockLen;
  }

  let systemBlockLen = null;
  let systemXML =
    moveCategory("system") ||
    system(isInitialSetup, isStage, targetId, customBlockColors.system);
  const systemDataList = curDeviceBlockList["system"];
  if (!systemDataList.includes("all")) {
    const filtedData = filterBlocks(systemXML, systemDataList);
    systemXML = filtedData.xml;
    systemBlockLen = filtedData.blockLen;
  }
  // const looksXML =
  //     moveCategory("looks") ||
  //     looks(
  //         isInitialSetup,
  //         isStage,
  //         targetId,
  //         costumeName,
  //         backdropName,
  //         colors.looks
  //     );
  // const soundXML =
  //     moveCategory("sound") ||
  //     sound(isInitialSetup, isStage, targetId, soundName, colors.sounds);
  // const eventsXML =
  //     moveCategory("event") ||
  //     events(isInitialSetup, isStage, targetId, colors.event);
  // const controlXML =
  //     moveCategory("control") ||
  //     control(isInitialSetup, isStage, targetId, colors.control);
  // const sensingXML =
  //     moveCategory("sensing") ||
  //     sensing(isInitialSetup, isStage, targetId, colors.sensing);
  // const operatorsXML =
  //     moveCategory("operators") ||
  //     operators(isInitialSetup, isStage, targetId, colors.operators);
  // const variablesXML =
  //     moveCategory("data") ||
  //     variables(isInitialSetup, isStage, targetId, colors.data);
  // const myBlocksXML =
  //     moveCategory("procedures") ||
  //     myBlocks(isInitialSetup, isStage, targetId, colors.more);

  let everything = [
    xmlOpen,
    motionXML,
    gap,
    displayXML,
    gap,
    voiceXML,
    gap,
    imageXML,
    gap,
    eventCustomXML,
    gap,
    timingXML,
    gap,
    systemXML,
  ];

  if (motionBlockLen === 0) {
    everything[1] = "";
    everything[2] = "";
  }

  if (displayBlockLen === 0) {
    everything[3] = "";
    everything[4] = "";
  }

  if (voiceBlockLen === 0) {
    everything[5] = "";
    everything[6] = "";
  }

  if (imageBlockLen === 0) {
    everything[7] = "";
    everything[8] = "";
  }

  if (eventBlockLen === 0) {
    everything[9] = "";
    everything[10] = "";
  }

  if (timingBlockLen === 0) {
    everything[11] = "";
    everything[12] = "";
  }

  if (systemBlockLen === 0) {
    everything[13] = "";
  }

  everything = everything.filter((item) => item !== "");

  for (const extensionCategory of categoriesXML) {
    everything.push(gap, extensionCategory.xml);
  }

  everything.push(xmlClose);
  return everything.join("\n");
};

export default makeToolboxXML;
